// components/admin/MultilingualInput/MultilingualInput.js
import React, { useState } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import './MultilingualInput.css';

const MultilingualInput = ({
    value = {},
    onChange,
    label,
    placeholder,
    type = 'text',
    required = false,
    error,
    isTextarea = false,
    rows = 3
}) => {
    const { availableLanguages, language: currentLanguage } = useLanguage();
    const [activeTab, setActiveTab] = useState(currentLanguage);

    // Ensure value is always an object
    const normalizedValue = typeof value === 'string'
        ? { [currentLanguage]: value }
        : (value || {});

    const handleInputChange = (lang, inputValue) => {
        const newValue = {
            ...normalizedValue,
            [lang]: inputValue
        };
        onChange(newValue);
    };

    const getPlaceholderText = (lang) => {
        const langName = availableLanguages.find(l => l.code === lang)?.name || lang;
        return `${placeholder || label} (${langName})`;
    };

    const hasContent = (lang) => {
        return normalizedValue[lang] && normalizedValue[lang].trim() !== '';
    };

    const InputComponent = isTextarea ? 'textarea' : 'input';

    return (
        <div className="multilingual-input">
            {label && (
                <label className="multilingual-label">
                    {label} {required && <span className="required">*</span>}
                </label>
            )}

            <div className="multilingual-tabs">
                {availableLanguages.map(lang => (
                    <button
                        key={lang.code}
                        type="button"
                        className={`multilingual-tab ${activeTab === lang.code ? 'active' : ''} ${hasContent(lang.code) ? 'has-content' : ''}`}
                        onClick={() => setActiveTab(lang.code)}
                    >
                        {lang.nativeName}
                        {hasContent(lang.code) && <span className="content-indicator">●</span>}
                    </button>
                ))}
            </div>

            <div className="multilingual-content">
                {availableLanguages.map(lang => (
                    <div
                        key={lang.code}
                        className={`multilingual-input-container ${activeTab === lang.code ? 'active' : ''}`}
                    >
                        <InputComponent
                            type={isTextarea ? undefined : type}
                            value={normalizedValue[lang.code] || ''}
                            onChange={(e) => handleInputChange(lang.code, e.target.value)}
                            placeholder={getPlaceholderText(lang.code)}
                            className={`multilingual-input-field ${error ? 'error' : ''}`}
                            rows={isTextarea ? rows : undefined}
                        />
                    </div>
                ))}
            </div>

            {error && <div className="multilingual-error">{error}</div>}
        </div>
    );
};

export default MultilingualInput;
